import { render } from "./SearchUser.vue?vue&type=template&id=beae1ce8&scoped=true&ts=true"
import script from "./SearchUser.vue?vue&type=script&lang=ts"
export * from "./SearchUser.vue?vue&type=script&lang=ts"

import "./SearchUser.vue?vue&type=style&index=0&id=beae1ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beae1ce8"]])

export default __exports__